/* eslint-disable react/button-has-type, react/jsx-props-no-spreading */
import { Button, Modal, ModalDialog as Dialog } from '@micromag/core/components';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';

const propTypes = {
    onConfirm: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    onSave: PropTypes.func,
    className: PropTypes.string,
};

const defaultProps = {
    onSave: null,
    className: null,
};

const ConfirmChanges = ({ onConfirm, onCancel, onSave, className }) => {
    const onSaveAndExit = useCallback(() => {
        if (onSave !== null) {
            onSave();
        }
        onConfirm();
    }, [onSave]);

    return (
        <Modal>
            <Dialog
                title={
                    <FormattedMessage
                        defaultMessage="Confirm unsaved changes"
                        description="Confirm unsaved changes modal title"
                    />
                }
                className={classNames([
                    {
                        [className]: className,
                    },
                ])}
                onClose={onCancel}
            >
                <Button onClick={onConfirm} className="m-2" theme="danger">
                    <FormattedMessage
                        defaultMessage="Exit without saving"
                        description="Exit without saving button label"
                    />
                </Button>
                <Button onClick={onCancel} className="m-2" theme="secondary">
                    <FormattedMessage
                        defaultMessage="Cancel and return to editor"
                        description="Cancel and return to editor button label"
                    />
                </Button>
                {onSave !== null ? (
                    <Button onClick={onSaveAndExit} className="m-2" theme="primary">
                        <FormattedMessage
                            defaultMessage="Save and exit"
                            description="Save and exit button label"
                        />
                    </Button>
                ) : null}
            </Dialog>
        </Modal>
    );
};

ConfirmChanges.propTypes = propTypes;
ConfirmChanges.defaultProps = defaultProps;

export default ConfirmChanges;
